import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import { store } from './store/store'
const fb = require('./firebaseconfig.js')

import { BootstrapVue, IconsPlugin   } from 'bootstrap-vue'

Vue.config.productionTip = false
Vue.use(VueRouter)

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin  )

import Host from "@/components/Host";
import HostHome from "@/components/HostHome";
import Client from "@/components/Client";
import ClientTest from "@/components/ClientTest";
import Login from "@/components/Login";
import Home from "@/components/Home";
import HomeTicket from "@/components/HomeTicket";
import AdminHome from "@/components/AdminHome";
import AdminTickets from "@/components/AdminTickets";
import AdminEvents from "@/components/AdminEvents";
import UserTickets from "@/components/AdminUsers";

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.prototype.$firebase = fb;

var router = new VueRouter({
    routes: [
        {
            path: '*',
            redirect: '/'
        },
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/admin',
            name: 'admin_home',
            component: AdminHome,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/events',
            component: AdminEvents,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/tickets',
            component: AdminTickets,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/users',
            component: UserTickets,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/host',
            component: HostHome,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/host/:channel/:folder',
            name: 'host_tour',
            component: Host,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/validate',
            name: 'validate_ticket',
            component: HomeTicket,
            props: true
        },
        {
            path: '/test',
            name: 'browser_Test',
            component: ClientTest,
            props: true
        },
        {
            path: '/client/:ticket',
            name: 'client_tour',
            component: Client,
            props: true
        }
    ]
})

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
    const currentUser = fb.auth.currentUser;

    console.log('------->', fb.auth.currentUser);

    if (requiresAuth && !currentUser) next({ path: '/login', query: { redirect: to.fullPath } })
    // else if (!requiresAuth && currentUser) next('/')
    // else if (!requiresAuth && !currentUser) next()
    else next()
})


let app
fb.auth.onAuthStateChanged(user => {
    if (user) {
        let docRef = fb.usersCollection.doc(user.uid)
        docRef.get().then(function(doc) {
            if (doc.exists) {
                let doc_data = doc.data();
                let user_data = {
                    id: user.uid,
                    lingua: doc_data.lingua,
                    nome: doc_data.nome,
                    role: doc_data.role
                }
                store.commit('setCurrentUserRole', user_data);
            } else {
                // doc.data() will be undefined in this case
                console.log("No such document!");
            }
        }.bind(this))
    }

    if (!app) {
        app = new Vue({
            router: router,
            store: store,
            render: h => h(App),
        }).$mount('#app')
    }
})
